import { render, staticRenderFns } from "./RecommendationPanel.vue?vue&type=template&id=2e6ec56b&lang=pug&"
import script from "./RecommendationPanel.vue?vue&type=script&lang=js&"
export * from "./RecommendationPanel.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationPanel.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports